import React from 'react';
import {
  Chip,
  makeStyles,
  useTheme,
} from '@material-ui/core';
import { getCookie, setCookie, eraseCookie } from 'src/utils/utils';

const useStyles = makeStyles((theme) => ({
  root:{}
}));

interface MockToggleProps {

}
const MockToggle: React.FC<MockToggleProps> = () => {

  const classes = useStyles();
  const theme = useTheme();
  const isMock = getCookie("useMock");

 if (process.env.REACT_APP_MOCK_ENABLE !== "true") return null

  const toggleMock = () => {
    if (isMock === "true") eraseCookie("useMock")
    else setCookie("useMock","true",100)
    window.location.reload()
  }

  return (
    <div className={classes.root}>
      <Chip 
        style={{
          backgroundColor:isMock === "true" ? theme.palette.primary.main : theme.palette.divider,
          color:"black",height:24
        }}
        label="mock"
        onClick={toggleMock}
      />
    </div>
  )
}

export default MockToggle;
